import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-logout',
  standalone: false,
  templateUrl: './logout.html',
  styleUrl: './logout.scss',
})
export class Logout implements OnInit, OnDestroy {
  private _unsubscribeAll = new Subject();
  constructor(
    private _route: ActivatedRoute,
    private _toastrServ: ToastrService,
    private _authServ: AuthService,
    private _router: Router
  ) {}
  ngOnInit(): void {
    this._route.queryParams.subscribe((params) => {
      const userId = params['id'];
      const token = params['token'];
      const users = this._authServ.users;
      const cu = this._authServ.currentUser;
      if (userId && token && users && users[userId])
        this.revokeToken(userId, token);
      else if (users && cu && users[cu]) {
        this.revokeToken(users[cu].user.id, users[cu].token);
      } else window.location.replace(environment.web_url);
    });
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  revokeToken(userId: string, token: string) {
    this._authServ
      .revokeToken(userId, token)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (res) => {
          this._authServ.removeUser(userId);
          setTimeout(() => {
            this._authServ.bc.postMessage('LOGOUT');
            window.location.replace(environment.web_url);
          }, 10);
        },
        error: (er) => {
          console.warn(er);
          this._authServ.removeUser(userId);
          setTimeout(() => {
            this._authServ.bc.postMessage('LOGOUT');
            window.location.replace(environment.web_url);
          }, 10);
          this._toastrServ.error('Something went wrong while logging out.');
        },
      });
  }
}
